export default '/build/0a3f88b0.png'